import { render, staticRenderFns } from "./datashareRegisterTest.vue?vue&type=template&id=1652de19&scoped=true"
import script from "./datashareRegisterTest.vue?vue&type=script&lang=js"
export * from "./datashareRegisterTest.vue?vue&type=script&lang=js"
import style0 from "./datashareRegisterTest.vue?vue&type=style&index=0&id=1652de19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1652de19",
  null
  
)

export default component.exports